import script from "./MenuIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuIndex.vue?vue&type=script&setup=true&lang=js"

import "./MenuIndex.vue?vue&type=style&index=0&id=55e66d10&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e66d10"]])

export default __exports__